<div class="form-footer">
  <div class="footer-left">
    <ng-content select="[footerLeft]"></ng-content>
  </div>
  <div class="footer-right">
    <ng-content select="[footerRight]"></ng-content>
  </div>
</div>
